<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">PaxelMarket - Meta</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Meta Title (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="meta-title-id"
          >
            <input
              v-model="item.meta_title_id"
              v-validate="'required'"
              name="meta_title_id"
              data-vv-as="Meta Title Bahasa"
              id="meta-title-id"
              class="form-control"
              placeholder="Meta title in Bahasa"
            />
            <b-form-invalid-feedback id="input-meta_title_id-feedback">{{
              veeErrors.first("meta_title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Meta Title (English)"
            label-class="control-label"
            class="required"
            label-for="meta-title-en"
          >
            <input
              v-model="item.meta_title_en"
              v-validate="'required'"
              name="meta_title_en"
              data-vv-as="Meta Title English"
              id="meta-title-en"
              class="form-control"
              placeholder="Meta title in English"
            />
            <b-form-invalid-feedback id="input-meta_title_en-feedback">{{
              veeErrors.first("meta_title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Meta Description (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="meta-description-id"
          >
            <input
              v-model="item.meta_description_id"
              v-validate="'required'"
              name="meta_description_id"
              data-vv-as="Meta Description Bahasa"
              id="meta-description-id"
              class="form-control"
              placeholder="Meta description in Bahasa"
            />
            <b-form-invalid-feedback id="input-meta_description_id-feedback">{{
              veeErrors.first("meta_description_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Meta Description (English)"
            label-class="control-label"
            class="required"
            label-for="meta-description-en"
          >
            <input
              v-model="item.meta_description_en"
              v-validate="'required'"
              name="meta_description_en"
              data-vv-as="Meta Description English"
              id="meta-description-en"
              class="form-control"
              placeholder="Meta description in English"
            />
            <b-form-invalid-feedback id="input-meta_description_en-feedback">{{
              veeErrors.first("meta_description_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Thumbnail"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>Thumbnail</b>
                <sup class="text-secondary pl-3"
                    >(1 MB)&nbsp;(360px x 320px)</sup
                  >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileThumbnail"
                  name="thumbnail"
                  data-vv-as="Thumbnail"
                  v-validate="
                    !item.thumbnail_jpg
                      ? 'required|minimalDimensions:360,320|ratiolDimensions:360,320|size:1000|ext:jpg,png'
                      : 'minimalDimensions:360,320|ratiolDimensions:360,320|size:1000|ext:jpg,png'
                  "
                  style="display: none"
                  v-on:change="onChangeFileThumbnail()"
                />
                <b-button
                  @click="$refs.fileThumbnail.click()"
                  v-show="!item.thumbnail_jpg && !fileThumbnail"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.thumbnail_jpg || fileThumbnail"
                  variant="primary"
                  @click="modalThumbnail = !modalThumbnail"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileThumbnail.click()"
                  v-show="item.thumbnail_jpg || fileThumbnail"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("thumbnail") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="SocMed Title (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="socmed-title-id"
          >
            <input
              v-model="item.social_media_title_id"
              v-validate="'required'"
              name="socmed_title_id"
              data-vv-as="SocMed Title Bahasa"
              id="socmed-title-id"
              class="form-control"
              placeholder="SocMed title in Bahasa"
            />
            <b-form-invalid-feedback id="input-socmed_title_id-feedback">{{
              veeErrors.first("socmed_title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="SocMed Title (English)"
            label-class="control-label"
            class="required"
            label-for="socmed-title-en"
          >
            <input
              v-model="item.social_media_title_en"
              v-validate="'required'"
              name="socmed_title_en"
              data-vv-as="SocMed Title English"
              id="socmed-title-en"
              class="form-control"
              placeholder="SocMed title in English"
            />
            <b-form-invalid-feedback id="input-socmed_title_en-feedback">{{
              veeErrors.first("socmed_title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="SocMed Description (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="socmed-description-id"
          >
            <input
              v-model="item.social_media_description_id"
              v-validate="'required'"
              name="socmed_description_id"
              data-vv-as="SocMed Description Bahasa"
              id="socmed-description-id"
              class="form-control"
              placeholder="SocMed description in Bahasa"
            />
            <b-form-invalid-feedback id="input-socmed_description_id-feedback">{{
              veeErrors.first("socmed_description_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="SocMed Description (English)"
            label-class="control-label"
            class="required"
            label-for="socmed-description-en"
          >
            <input
              v-model="item.social_media_description_en"
              v-validate="'required'"
              name="socmed_description_en"
              data-vv-as="SocMed Description English"
              id="socmed-description-en"
              class="form-control"
              placeholder="SocMed description in English"
            />
            <b-form-invalid-feedback id="input-socmed_description_en-feedback">{{
              veeErrors.first("socmed_description_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'PaxelMarketMeta' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">Batal</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="col-2"
            size="lg"
          >
            Simpan
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalThumbnail" title="Preview Image" size="xl">
      <img
        v-show="!fileThumbnail"
        v-if="item.thumbnail_jpg"
        width
        height="400px"
        :src="item.thumbnail_jpg"
      />
      <img
        v-show="fileThumbnail"
        v-if="urlThumbnail"
        width
        height="400px"
        :src="urlThumbnail"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        meta_title_id: "",
        meta_title_en: "",
        meta_description_id: "",
        meta_description_en: "",
        thumbnail_jpg: "",
        social_media_title_id: "",
        social_media_title_en: "",
        social_media_description_id: "",
        social_media_description_en: ""
      },
      loading: false,
      modalThumbnail: false,
      fileThumbnail: "",
      urlThumbnail: ""
    }
  },
  beforeMount() {
    this.$store
        .dispatch("PaxelMarketMetaModule/getMeta")
        .then(response => {
          const data = response.data.data
          if(response.data.data) {
            this.item = response.data.data
          } else {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: "Your data could not be fetched",
              showConfirmButton: false,
              timer: 1500
            });  
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Your data data could not be fetched",
            showConfirmButton: false,
            timer: 1500
          });
        });
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("meta_title_id", this.item.meta_title_id);
          formData.append("meta_title_en", this.item.meta_title_en);
          formData.append("meta_description_id", this.item.meta_description_id);
          formData.append("meta_description_en", this.item.meta_description_en);
          formData.append("thumbnail_jpg", this.fileThumbnail);
          formData.append("social_media_title_id", this.item.social_media_title_id);
          formData.append("social_media_title_en", this.item.social_media_title_en);
          formData.append("social_media_description_id", this.item.social_media_description_id);
          formData.append("social_media_description_en", this.item.social_media_description_en);
          this.$store
            .dispatch("PaxelMarketMetaModule/postMeta", formData)
            .then((response) => {
              this.loading = false;
              this.$validator.reset();
              // this.$router.push({ name: "PaxelMarketMeta" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    onChangeFileThumbnail() {
      this.fileThumbnail = this.$refs.fileThumbnail.files[0];
      const input = this.$refs.fileThumbnail;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlThumbnail = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>

<style>
</style>